import { Outlet } from "@tanstack/react-router";
import type { FC } from "react";
import styles from "@/layouts/AuthLayout/AuthLayout.module.css";
import AuthPromoPanel from "@/layouts/AuthLayout/AuthPromoPanel";

const AuthLayout: FC = () => (
  <div className={styles.shell}>
    <AuthPromoPanel />
    <div className={styles.contentPanel}>
      <Outlet />
    </div>
  </div>
);

export default AuthLayout;
